import { FC } from 'react';
// Components
import LandingPage from 'pages/OwnerPage/QuizFormPage/TabContentPages/SystemPages/LandingPage';
import SectionPrizes from 'pages/OwnerPage/QuizFormPage/TabContentQuiz/SectionPrizes';

// Landing Page + Prizes, each in its own accordion (mirrors QuizStyleEditDialog's
// composition of standalone sections). Landing Page starts expanded since it's
// the reason this dialog was opened; Prizes stays collapsed until needed.
// showPreview is off — its Preview button needs a :quizId route param that
// doesn't exist inside QuizAgentDialog.
const LandingPageForm: FC = () => (
  <div className="w-full">
    <LandingPage defaultExpanded showPreview={false} />
    <SectionPrizes />
  </div>
);

export default LandingPageForm;
